import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { MarsGroup } from 'app/mars/models/MarsGroup';
import { MarsGroupSurveysListService } from './mars-group-surveys-list.service';
import { StoreService } from 'core/services/store.service';
import { MarsGroupService } from '../../../services/mars-groups.service';

@Component({
  selector: 'lms-mars-group-surveys',
  templateUrl: './mars-group-surveys.component.html',
  styleUrls: ['./mars-group-surveys.component.scss'],
  providers: [MarsGroupSurveysListService]
})
export class MarsGroupSurveysComponent implements OnInit, OnChanges {
  @Input() group: MarsGroup;
  public listId = 'MARS_GROUPS_LIST';
  public toolbarConfig: any;
  public noGroups: boolean;
  public dataSource: TableDatasource;
  public summary: any;
  ratioApplication: number;
  ratioRecommendation: number;
  opinionsSummary: any[];

  constructor(private surveysListService: MarsGroupSurveysListService, private marsGroupService: MarsGroupService) {}

  ngOnInit(): void {
    this.toolbarConfig = {
      list: {
        listId: this.listId,
        download: true,
        filterRow: true,
        columnChooser: false,
        hidePrint: true,
        hideSearch: true,
        skeletor: true
      }
    };
  }

  ngOnChanges(): void {
    this.getDataSource();
  }

  async getDataSource() {
    this.dataSource = await this.surveysListService.getDatasource(this.listId, this.group);
    this.getSurveysSummary();
  }

  onDatasourceUpdate() {
    StoreService.update(this.listId, this.dataSource);
    this.getSurveysSummary();
  }

  getSurveysSummary() {
    const filters = this.surveysListService.getDatasourceFilters(this.dataSource);
    this.marsGroupService.getGroupSurveysSummary(this.group.id, filters).then((summary) => {
      this.summary = summary;
      this.ratioApplication = this.getRatioApplication();
      this.ratioRecommendation = this.getRatioRecommendation();
      this.opinionsSummary = this.getOpinionsSummary();
    });
  }

  getRatioApplication() {
    return this.summary ? Math.round(this.summary.ratioApplication * 10) / 10 : 0;
  }

  getRatioRecommendation() {
    return this.summary ? Math.round(this.summary.ratioRecommendation * 10) / 10 : 0;
  }

  getOpinionsSummary() {
    const scores = this.summary && this.summary.scoring ? this.summary.scoring : [];
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((points) => {
      const score = scores.find((s) => s.points === points);
      return {
        label: points,
        value: score ? score.total : 0,
        percentage: score ? Math.round((score.total / this.summary.surveysCount) * 100) : 0
      };
    });
  }
}
